import {get, post } from './http';

//日报记录
export const getDailyReport = (params) => get("/min-program/v1/report/day", params);

//周报记录
export const getWeekReport = (params) => get("/min-program/v1/report/week", params);